var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBigArrowLeft56 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M37.854 7.146a.5.5 0 0 1 0 .708L18.207 27.5l19.647 19.646a.5.5 0 0 1-.708.708l-20-20a.5.5 0 0 1 0-.708l20-20a.5.5 0 0 1 .708 0Z",
  clipRule: "evenodd"
})));
export { SvgBigArrowLeft56 as ReactComponent };
export default __webpack_public_path__ + "04c98063bbd397c288f3ffe317e8516c.svg";